import "./ButtonDetails.scss";

export default function ButtonDetails() {

    return (
        <button className="btn-detail">ДЕТАЛЬНІШЕ</button>
    );
}
